import React from 'react';
import { connect } from 'react-redux';
import { Button, buttonTypes } from 'moods-react/Button';
import { Notification, NotificationType } from 'moods-react/Notification';

import './AddressUpload.scss';
import createReducer from '../../helpers/createReducer';

const ACTION_UPLOAD_CSV = 'ACTION_UPLOAD_CSV';
const ACTION_CHANGE_FILE = 'ACTION_CHANGE_FILE';
const ACTION_UPLOAD_CSV_SUCCESS = 'ACTION_UPLOAD_CSV_SUCCESS';
const ACTION_UPLOAD_CSV_FAILURE = 'ACTION_UPLOAD_CSV_FAILURE';

const AddressUploadComponent = (props) => {
  let notification = null;
  if (props.notification != null) {
    const notificationType = props.notification.error ? NotificationType.Error : NotificationType.Information;

    notification = (
      <Notification type={notificationType} visible className="u-marginBottom-m">
        <p className="notification__text">{props.notification.message}</p>
      </Notification>
    );
  }

  const fileDetails = (
    <div className="fileDetails">
      {props.selectedFile != null && (
        <div className="u-paddingTop-m">
          <h5>File Details:</h5>
          <table className="table -col-1-heading u-marginBottom-0">
            <tbody>
              <tr>
                <th>Name:</th>
                <td>{props.selectedFile.name}</td>
              </tr>
              {props.selectedFile.type === undefined ? null : (
                <tr>
                  <th>Type:</th>
                  <td>{props.selectedFile.type}</td>
                </tr>
              )}
              {props.selectedFile.size === undefined ? null : (
                <tr>
                  <th>Size:</th>
                  <td>{Math.ceil(props.selectedFile.size / 1024)}kb</td>
                </tr>
              )}
              {props.selectedFile.lastModifiedDate === undefined ? null : (
                <tr>
                  <th>Modified:</th>
                  <td>
                    {props.selectedFile.lastModifiedDate.toDateString()}
                    at {props.selectedFile.lastModifiedDate.toLocaleTimeString()}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );

  const disableUploadButton = props.selectedFile == null || props.uploading;

  return (
    <div className="address-upload-page u-padding-xl">
      {notification}
      <div className="panel">
        <div className="panel__header">
          <h4>Add Addresses</h4>
        </div>
        <div className="panel__body">
          <p>Addresses will be uploaded to your user account</p>
          <input type="file" className="text-input" onChange={(event) => props.onFileChange(event.target.files[0])} />
          {fileDetails}
          <div className="u-paddingTop-m">
            <Button
              onClick={() => props.uploadCSV(props.selectedFile)}
              type={buttonTypes.PRIMARY}
              isDisabled={disableUploadButton}
            >
              Upload CSV
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const initialUploadPageState = {
  notification: null,
  selectedFile: null,
  uploading: false,
};

// define functions to perform dispatches (actions that can change the redux store state)
const mapDispatchToProps = {
  uploadCSV: (file) => {
    const thunk = async (dispatch, getState, baseApiUrl) => {
      dispatch({ type: ACTION_UPLOAD_CSV });

      const formData = new FormData();
      formData.append('file', file);

      fetch(`${baseApiUrl}/addresses`, {
        method: 'POST',
        body: formData,
      })
        .then((response) => {
          const contentType = response.headers.get('Content-Type');
          if (contentType.indexOf('text/html') >= 0) {
            // not an app-generated response
            return response.text().then((text) => {
              throw new Error(text);
            });
          }
          return response.text().then((text) => {
            if (response.status === 200) {
              return {
                message: 'Addresses loaded. Yay!',
                error: false,
              };
            }
            return {
              message: text,
              error: true,
            };
          });
        })
        .then((notification) => {
          dispatch({ type: ACTION_UPLOAD_CSV_SUCCESS, notification });
        })
        .catch(() => {
          const notification = {
            message: 'We had trouble talking to the system. Check your internet and try again!',
            error: true,
          };
          dispatch({ type: ACTION_UPLOAD_CSV_FAILURE, notification });
        });
    };
    return thunk;
  },
  onFileChange: (file) => {
    const thunk = (dispatch) => {
      dispatch({ type: ACTION_CHANGE_FILE, file });
    };
    return thunk;
  },
};

// used for selecting the part of the data from the redux store that the connected component needs
const mapStateToProps = ({ addressUpload }) => ({ ...addressUpload });

export const addressUploadReducer = createReducer(initialUploadPageState, {
  [ACTION_UPLOAD_CSV]: (state) => {
    return {
      ...state,
      notification: null,
      uploading: true,
    };
  },
  [ACTION_CHANGE_FILE]: (state, { file }) => {
    return {
      ...state,
      selectedFile: file,
      uploading: false,
      notification: null,
    };
  },
  [ACTION_UPLOAD_CSV_FAILURE]: (state, { notification }) => {
    return {
      ...state,
      uploading: false,
      notification,
    };
  },
  [ACTION_UPLOAD_CSV_SUCCESS]: (state, { notification }) => {
    return {
      ...state,
      uploading: false,
      notification,
    };
  },
});

AddressUploadComponent.displayName = 'AddressUpload';

export default connect(mapStateToProps, mapDispatchToProps)(AddressUploadComponent);
